import React, { createContext, useState } from "react";
import BuRunCharges_Service from "../services/buRunChargeServices";

const initialState = {
  loading: false,
  BuRunCharges: [],
};

const BuRunChargesContext = createContext();

const BuRunChargesContextProvider = ({ children }) => {
  const [state, setState] = useState(initialState);

  const getAllBuRunCharges = async () => {
    setState({ ...state, loading: true });
    const data = await BuRunCharges_Service.getAllBuRunCharges();
    setState({ BuRunCharges: data, loading: false });
  };

  const value = { state, setState, getAllBuRunCharges };
  return (
    <BuRunChargesContext.Provider value={value}>
      {children}
    </BuRunChargesContext.Provider>
  );
};

const useBuRunChargesContext = () => {
  const context = React.useContext(BuRunChargesContext);
  if (context === undefined) {
    throw new Error(
      "BuRunChargesContext must be used within a BuRunChargesContextProvider"
    );
  }
  return context;
};

export { BuRunChargesContextProvider, useBuRunChargesContext };
